import { Link } from "react-router-dom";

import useAnchorNav from "../hooks/useAnchorNav";
import useI18n from "../i18n/useI18n";
import logo from "../assets/images/white logo.png";

const socials = [
  { id: "linkedin", label: "in", href: "https://www.linkedin.com" },
  { id: "facebook", label: "fb", href: "https://www.facebook.com" },
  { id: "instagram", label: "ig", href: "https://www.instagram.com" },
];

const FooterComponent = () => {
  const navigateToHash = useAnchorNav();
  const { t } = useI18n();

  const handleAnchor = (event, id) => {
    event.preventDefault();
    navigateToHash(id);
  };

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <img src={logo} alt="CodeIL" className="site-footer__logo" />
            <p>{t("footer.tagline")}</p>
            <div className="site-footer__socials">
              {socials.map((item) => (
                <a key={item.id} href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.id}>
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <nav className="site-footer__col" aria-label={t("footer.colServices")}>
            <h3>{t("footer.colServices")}</h3>
            <Link to="/services">{t("footer.allServices")}</Link>
            <Link to="/blog">{t("nav.blog")}</Link>
            <a href="#projects" onClick={(event) => handleAnchor(event, "projects")}>
              {t("footer.caseStudies")}
            </a>
            <a href="#contact" onClick={(event) => handleAnchor(event, "contact")}>
              {t("footer.startProject")}
            </a>
          </nav>

          <nav className="site-footer__col" aria-label={t("footer.colCompany")}>
            <h3>{t("footer.colCompany")}</h3>
            <Link to="/story">{t("nav.story")}</Link>
            <a href="#faq" onClick={(event) => handleAnchor(event, "faq")}>
              {t("nav.faq")}
            </a>
            <a href="#ai" onClick={(event) => handleAnchor(event, "ai")}>
              AI Architect
            </a>
          </nav>

          <nav className="site-footer__col" aria-label={t("footer.colLegal")}>
            <h3>{t("footer.colLegal")}</h3>
            <a href="/privacy-policy">{t("footer.privacy")}</a>
            <a href="/terms-of-service">{t("footer.terms")}</a>
            <a href="mailto:info@codeil.org">info@codeil.org</a>
            <a href="tel:+972502215233" dir="ltr">050-2215233</a>
          </nav>
        </div>

        <div className="site-footer__bottom">
          <span>{t("footer.rights")}</span>
          <span dir="ltr" className="site-footer__stamp">
            {t("footer.stamp")}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
